export const FACILITIES_CLIENT = ['E-302', 'E-303'];
